import type { ReactNode } from 'react'
import { FormGroup, FormRow, Help } from '@/components/Form'

export interface ClientTeamInputEditorProps {
  error?: string
  clientTeamSelect: ReactNode
}

/**
 * Picks the Client team to transfer the job to.
 */
export function ClientTeamInputEditor({
  error,
  clientTeamSelect,
}: ClientTeamInputEditorProps) {
  return (
    <FormRow>
      <FormGroup label="New Client Team">
        {clientTeamSelect}
        <Help
          error={error}
          help={
            <>
              Make sure that the Client and/or Team you are transferring to has
              a valid billing method!
            </>
          }
        />
      </FormGroup>
    </FormRow>
  )
}
